<template>
  <div class="product-details">
    <div class="image" :style="imageStyle">&nbsp;</div>
    <div class="description">
      <h1 class="description__title">{{ product.DESCRIPCION }}</h1>
      <div
        class="description__details"
        v-if="product.DETALLES && product.DETALLES != ''"
        v-html="product.DETALLES"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    product: { required: true },
  },
  computed: {
    imageStyle() {
      const image = this.product.IMAGENURL
      return image ? { backgroundImage: `url(${image})` } : { display: 'none' }
    },
  },
}
</script>
<style lang="scss">
.product-details {
  .description__details {
    white-space: pre-line;
  }
  @media screen and (max-width: 340px) {
    max-height: 7.25rem;
    .image {
      max-width: 80px;
      min-height: 6rem !important;
    }
    .description__title {
      font-size: 0.82rem !important;
    }
    .description__details {
      font-size: 0.7rem !important;
      margin-bottom: 0;
      overflow-y: scroll;
    }
  }
}
</style>
